import { log, Style } from "./helpers";
var SESSION_STORAGE_KEYS = {
    DASHBOARD_GROUP_ID: "bf_group_key",
    DASHBOARD_ORDER_ID: "bf_order_key",
    BF_PAYMENT: "bf_payment",
    SEAT_CODE: "bf_seatcode"
};
var setInSessionStorage = function (key, value) {
    var encodedValue = encodeURIComponent(value);
    window.self.sessionStorage.setItem(key, window.btoa(encodedValue));
};
var getFromSessionStorage = function (key) {
    var val = window.self.sessionStorage.getItem(key);
    if (val) {
        return decodeURIComponent(window.atob(val));
    }
    else
        return null;
};
var removeFromSessionStorage = function (key) {
    if (window.brushfireDebugMode) {
        log("Cleared ".concat(key, " from session storage"), Style.base);
    }
    window.self.sessionStorage.removeItem(key);
};
export { SESSION_STORAGE_KEYS, getFromSessionStorage, setInSessionStorage, removeFromSessionStorage };
